import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition, query, keyframes, state } from '@angular/animations';
import { ApiService } from "../../app/api.service";

declare var Hammer:any;
declare var $ :any;

@Component({
	selector: 'components-swiper',
	templateUrl: './component.swiper.html',
	styleUrls: ['./component.swiper.css']
})
export class ComponentsSwiper implements OnInit, AfterViewInit {

	@Input() studyReport:any;
	@Output() Close = new EventEmitter<any>();
	
	constructor(private  apiService: ApiService) {
		
	}

	ngOnInit() {
		this.apiService.ajax({
    		"type":"get",
	        "url": '/sr/incentiveLine/getIncentiveLineUserReport'
    	}).subscribe((result)=>{
    		this.studyReport = result;
    	});
	}
		
	ngAfterViewInit(){
		$("#swiperCloser").hide();
		var hammertime = new Hammer(document.getElementById('swipeContainer'));
		hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
		hammertime.on('swipeup swipedown', this.logEventType);
	}
	
	logEventType(ev){
		let currentLI = $("#swipeContainer .current");
		let currentPre = $("#swipeContainer .pre");
		let currentNext = $("#swipeContainer .next");
		//向上
		if(ev.type == "swipeup"){
			let nextObj = currentLI.next();
			if(nextObj.length == 1){
				currentPre.removeClass("pre");
				currentNext.removeClass("next");
				currentLI.removeClass("current").addClass("pre");
				nextObj.addClass("current");
				if(nextObj.next().length == 0){
					$("#swiperCloser").show();
					$("#swiperArrow").hide();
				}
			}
			
		}
		//向下
		if(ev.type == "swipedown"){
			let preObj = currentLI.prev();
			if(preObj.length == 1){
				currentPre.removeClass("pre");
				currentNext.removeClass("next");

				currentLI.removeClass("current").addClass("next");
				preObj.addClass("current");
				preObj.prev().addClass("pre");
			}
			$("#swiperCloser").hide();
			$("#swiperArrow").show();
		}
	}
	
	CloseSwiper(){
		this.Close.emit();
	}
}


// WEBPACK FOOTER //
// ./src/component/swiper/component.swiper.ts